<template>
	<div>

		<stato-fase
			:fase-with-stati="faseWithStati"
			:pratica="pratica"
			:pratica-diff="praticaDiff"
			@update-id-stato="pratica.id_stato_fase_4 = $event"
			:disabled="isLoading"
			:action="action"
		></stato-fase>

		<!--<div-->
		<!--	:style="`height: 1px; background-color: ${$vuetify.theme.currentTheme.primary}`"-->
		<!--	class="my-4"-->
		<!--&gt;</div>-->

		<!--<v-row class="mb-5 font-weight-medium">-->
		<!--	<v-col>-->
		<!--		<div v-html="faseWithStati.descrizione"></div>-->
		<!--	</v-col>-->
		<!--</v-row>-->

		<v-row>
			<v-col>
				<template v-if="(action == 'store' && isAccountManager)
					|| (action == 'edit' && ((isCoordinatore && pratica.id_stato_fase_4 != idStatoClickDayEffettuato) || isAccountManager))"
				>
					<v-badge
						:value="haveFilesBeenModified.screenshot_invio"
						class="d-block"
						color="info"
						overlap
						right
						icon="mdi-pencil"
					>
						<v-file-input
							v-model="files.screenshot_invio"
							label="Screenshot schermata del click"
							hide-details
							outlined
							dense
							clearable
							accept="image/png, image/jpeg, image/jpg"
							truncate-length="120"
							@change="setChanged(files.screenshot_invio)"
							@click:clear="pratica.path_screenshot_invio = null"
							:loading="isLoadingScreenshotInvio"
							:disabled="isLoading"
						>
							<template
								v-slot:append
								v-if="pratica.path_screenshot_invio !== null && !isLoadingScreenshotInvio"
							>
								<template>
									<v-progress-circular
										v-if="downloadingScreenshotInvio"
										size="24"
										width="3"
										color="primary"
										indeterminate
									></v-progress-circular>
									<v-icon
										v-else
										class="ml-3"
										@click="download(pratica.path_screenshot_invio, 'screenshot_invio')"
									>
										mdi-tray-arrow-down
									</v-icon>
								</template>
								<v-icon
									class="ml-3"
									@click="viewFileInBrowser(files.screenshot_invio)"
								>
									mdi-eye-outline
								</v-icon>
							</template>
						</v-file-input>
					</v-badge>
				</template>

				<template v-else-if="action == 'show'
					|| (isCoordinatore && pratica.id_stato_fase_4 == idStatoClickDayEffettuato)"
				>
					<v-text-field
						:value="getFileNameFromPath(pratica.path_screenshot_invio)"
						label="Screenshot schermata del click"
						hide-details
						outlined
						dense
						readonly
					>
						<template
							v-slot:append
							v-if="pratica.path_screenshot_invio !== null"
						>
							<template>
								<v-progress-circular
									v-if="downloadingScreenshotInvio"
									size="24"
									width="3"
									color="primary"
									indeterminate
								></v-progress-circular>
								<v-icon
									v-else
									class="ml-3"
									@click="download(pratica.path_screenshot_invio, 'screenshot_invio')"
								>
									mdi-tray-arrow-down
								</v-icon>
							</template>
							<template>
								<v-progress-circular
									v-if="isGettingFile.screenshot_invio"
									size="24"
									width="3"
									color="primary"
									indeterminate
									class="ml-3"
								></v-progress-circular>
								<v-icon
									v-else
									class="ml-3"
									@click="getFileAndViewInBrowser(pratica.path_screenshot_invio, 'screenshot_invio')"
								>
									mdi-eye-outline
								</v-icon>
							</template>
						</template>
					</v-text-field>
				</template>

				<div
					v-if="pratica.path_screenshot_invio && !isCliente"
					class="mt-2"
				>
					Screenshot caricato il {{ getDateFromDateTime(pratica.data_ora_screenshot_invio) }}
				</div>
			</v-col>
		</v-row>

		<v-row>
			<v-col>
				<template v-if="(action == 'store' || action == 'edit') && isAccountManager">
					<v-badge
						:value="haveFilesBeenModified.ricevuta_click_day"
						class="d-block"
						color="info"
						overlap
						right
						icon="mdi-pencil"
					>
						<v-file-input
							v-model="files.ricevuta_click_day"
							label="Ricevuta del Click"
							hide-details
							outlined
							dense
							clearable
							accept="application/pdf"
							truncate-length="120"
							@change="setChanged(files.ricevuta_click_day)"
							@click:clear="pratica.path_ricevuta_click_day = null"
							:loading="isLoadingRicevuta"
							:disabled="isLoading"
						>
							<template
								v-slot:append
								v-if="pratica.path_ricevuta_click_day !== null && !isLoadingRicevuta"
							>
								<template>
									<v-progress-circular
										v-if="downloadingRicevuta"
										size="24"
										width="3"
										color="primary"
										indeterminate
									></v-progress-circular>
									<v-icon
										v-else
										class="ml-3"
										@click="download(pratica.path_ricevuta_click_day, 'ricevuta_click_day')"
									>
										mdi-tray-arrow-down
									</v-icon>
								</template>
							</template>
						</v-file-input>
					</v-badge>
				</template>

				<template v-else-if="action == 'show'">
					<v-text-field
						:value="getFileNameFromPath(pratica.path_ricevuta_click_day)"
						label="Ricevuta del Click"
						hide-details
						outlined
						dense
						readonly
					>
						<template
							v-slot:append
							v-if="pratica.path_ricevuta_click_day !== null"
						>
							<template>
								<v-progress-circular
									v-if="downloadingRicevuta"
									size="24"
									width="3"
									color="primary"
									indeterminate
								></v-progress-circular>
								<v-icon
									v-else
									class="ml-3"
									@click="download(pratica.path_ricevuta_click_day, 'ricevuta_click_day')"
								>
									mdi-tray-arrow-down
								</v-icon>
							</template>
						</template>
					</v-text-field>
				</template>

				<div
					v-if="pratica.path_ricevuta_click_day && !isCliente"
					class="mt-2"
				>
					Ricevuta caricata il {{ getDateFromDateTime(pratica.data_ora_ricevuta) }}
				</div>
			</v-col>
		</v-row>

		<template v-if="!isCliente || (isCliente && pratica.id_stato_fase_4 == idStatoClickDayEffettuato)">
			<v-row>
				<v-col cols="6">
					<template v-if="isCliente">
						<v-row v-if="pratica.path_screenshot_invio">
							<v-col class="d-flex justify-space-between align-center">
								<div>
									Screenshot caricato il {{ getDateFromDateTime(pratica.data_ora_screenshot_invio) }}
								</div>
								<v-btn
									color="secondary"
									@click="download(pratica.path_screenshot_invio, 'screenshot_invio')"
									:disabled="isLoadingBase64ScreenshotInvio"
									:loading="downloadingScreenshotInvio"
								>
									Scarica
								</v-btn>
							</v-col>
						</v-row>

						<v-row v-if="pratica.path_ricevuta_click_day">
							<v-col class="d-flex justify-space-between align-center">
								<div>
									Ricevuta caricata il {{ getDateFromDateTime(pratica.data_ora_ricevuta) }}
								</div>
								<v-btn
									color="secondary"
									@click="download(pratica.path_ricevuta_click_day, 'ricevuta_click_day')"
									:disabled="isLoadingRicevuta"
									:loading="downloadingRicevuta"
								>
									Scarica
								</v-btn>
							</v-col>
						</v-row>
					</template>

					<v-row v-if="pratica.path_screenshot_invio">
						<v-col>
							<v-progress-linear
								v-if="isLoadingBase64ScreenshotInvio"
								indeterminate
							></v-progress-linear>
							<v-img
								v-else
								:src="base64ScreenshotInvio"
								contain
							></v-img>
						</v-col>
					</v-row>
				</v-col>
				<v-col cols="6">
					<v-badge
						v-if="!isCliente"
						:value="praticaDiff.includes('descrizione_screenshot_invio')"
						class="d-block"
						color="info"
						overlap
						right
						icon="mdi-pencil"
					>
						<v-textarea
							label="Descrizione Screenshot Schermata del Click"
							outlined
							:value="pratica.descrizione_screenshot_invio"
							@input="pratica.descrizione_screenshot_invio = $event !== '' ? $event : null"
							:readonly="!isAccountManager"
							:disabled="isLoading"
							persistent-placeholder
							auto-grow
						></v-textarea>
					</v-badge>

					<p
						v-else-if="isCliente && pratica.descrizione_screenshot_invio"
						v-html="pratica.descrizione_screenshot_invio"
					></p>
				</v-col>
			</v-row>
		</template>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import { eventBus } from "@/event-bus";
export default {
	props: ['value', 'action', 'faseWithStati', 'praticaDiff', 'haveFilesBeenModified'],
	data() {
		return {
			pratica: {
				id: null,
				id_stato_fase_4: null,
				ci_sono_aggiornamenti_fase_4: false,
				path_screenshot_invio: null,
				descrizione_screenshot_invio: null,
				data_ora_screenshot_invio: null,
				path_ricevuta_click_day: null,
				data_ora_ricevuta: null
			},
			files: {
				screenshot_invio: null,
				ricevuta_click_day: null
			},

			idStatoClickDayEffettuato: 189,

			isLoadingScreenshotInvio: false,
			downloadingScreenshotInvio: false,
			isLoadingBase64ScreenshotInvio: false,
			base64ScreenshotInvio: null,

			isLoadingRicevuta: false,
			downloadingRicevuta: false
		}
	},

	created() {
		this.isSettingPratica = true;
		// this.pratica = Object.assign({}, this.value);
		this.pratica = this.value;
		this.isSettingPratica = false;

		if (this.pratica.ci_sono_aggiornamenti_fase_4 && this.isCliente) {
			this.pratica.ci_sono_aggiornamenti_fase_4 = false;
			this.$emit('input', this.pratica);
			this.$emit('aggiornamenti-visualizzati', {
				praticaId: this.pratica.id,
				aggiornamentoKey: 'ci_sono_aggiornamenti_fase_4',
				aggiornamentoValue: false
			});
			this.salvaAggiornamentiVisualizzati(this.pratica.id, 'ci_sono_aggiornamenti_fase_4');
		}

		if (this.pratica.path_screenshot_invio !== null) {
			this.getBase64ScreenshotInvio();

			if (this.action != 'show' && !this.isCliente) this.getScreenshotInvio();
		}

		if (this.pratica.path_ricevuta_click_day !== null) {
			this.getRicevutaClickDay();
		}
	},

	computed: {
		...mapGetters({
			isAccountManager: 'auth/isAccountManager',
			isCliente: 'auth/isCliente',
			isCoordinatore: 'auth/isCoordinatore'
		}),
		isLoading() {
			return this.isSettingPratica
				|| this.isLoadingScreenshotInvio;
		}
	},

	watch: {
		pratica: {
			handler(newPratica) {
				if (!this.isLoading) {
					this.$emit('input', newPratica)
				}
			},
			deep: true
		},
		files: {
			handler(newFiles) {
				if (!this.isLoading) {
					this.$emit('update-files', newFiles)
				}
			},
			deep: true
		},
		isLoading(newVal) {
			this.$emit('is-loading', newVal)
		},
	},

	methods: {
		async getScreenshotInvio() {
			this.isLoadingScreenshotInvio = true;
			this.files.screenshot_invio = await this.getFile(this.pratica.path_screenshot_invio);
			this.files.screenshot_invio.changed = false;
			this.isLoadingScreenshotInvio = false;
		},
		getBase64ScreenshotInvio() {
			this.isLoadingBase64ScreenshotInvio = true;
			return axios.post('/api/storage/get-base-64-file', { path: this.pratica.path_screenshot_invio})
				.then(response => {
					this.base64ScreenshotInvio = response.data;
				})
				.finally(() => {
					this.isLoadingBase64ScreenshotInvio = false;
				})
		},
		async getRicevutaClickDay() {
			this.isLoadingRicevuta = true;
			this.files.ricevuta_click_day = await this.getFile(this.pratica.path_ricevuta_click_day);
			this.files.ricevuta_click_day.changed = false;
			this.isLoadingRicevuta = false;
		},
		download(path, key) {
			const fileName = this.getFileNameFromPath(path);
			if (key == 'screenshot_invio') this.downloadingScreenshotInvio = true;
			else if (key == 'ricevuta_click_day') this.downloadingRicevuta = true;
			axios.post('/api/storage/download',
				{
					path: path
				},
				{
					responseType: 'blob'
				})
				.then(response => {
					saveAs(response.data, fileName);
				})
				.finally(() => {
					if (key == 'screenshot_invio') this.downloadingScreenshotInvio = false;
					else if (key == 'ricevuta_click_day') this.downloadingRicevuta = false;
				})
		},
		setChanged(file) {
			if (file !== null && !this.isLoading) file.changed = true;
		},
	}

}
</script>

<style scoped>

</style>
